// src/components/projects.tsx
"use client";

import ProjectCard from "./project-card";

const PROJECTS = [
  {
    img: "/image/lucky-day.jpg",
    title: "Lucky Day",
    desc: "Karina drifts through a sunlit park, lost in her own thoughts and a playlist so loud the world fades away. A chance stumble before a charming stranger and a discarded scrap of paper promise a turn of fate—one that blurs the line between discovery and delusion. When excitement collides with her deepest fears, Karina must decide what—and who—she can really trust.",
    href: "https://youtu.be/2ivkNqRGR3M",
  },
  {
    img: "/image/contact-from-beyond.png",
    title: "Contact From Beyond",
    desc: "On a seemingly ordinary day at the park, a couple finds themselves caught up in a series of unexpected events after discovering something mysterious. Secrets threaten to be revealed, challenging their trust and leading to intense, emotional situations.",
    href: "https://youtu.be/opqON4iiJL0",
  },
  {
    img: "/image/meet-me.png",
    title: "Meet Me",
    desc: "Meet Me is a captivating short film that explores the intriguing connection between dreams and reality. As Rob searches for a mysterious woman named Anna, he finds himself trapped between the boundaries of his dreams and waking life. With twists that blur the lines between fantasy and truth, the film takes viewers on a journey of self-discovery, love, and the unexpected connections that can transcend time and space. Through a dynamic narrative and compelling characters, Meet Me challenges perceptions and leaves the audience questioning the nature of fate and coincidence.",
    href: "https://www.imdb.com/title/tt36070830",
  },
  {
    img: "/image/ptom.png",
    title: "Prefer the Old Me",
    desc: "Videoclip for my latest music single.",
    href: "#",
  },
];

export default function Projects() {
  return (
    <section className="py-28 px-8" id="film">
      <div className="container mx-auto mb-20 text-center">
        <h2 className="mb-4 text-3xl lg:text-4xl font-bold text-blue-gray-900">
          My Films
        </h2>
        <p className="mx-auto w-full px-4 font-normal text-gray-500 lg:w-6/12">
          Creating stories and transforming them to films it is like my music stories but with acting and love for the performing arts.
        </p>
      </div>

      <div className="container mx-auto grid grid-cols-1 gap-x-10 gap-y-20 md:grid-cols-2 xl:grid-cols-4">
        {PROJECTS.map((props, idx) => (
          <ProjectCard key={idx} {...props} />
        ))}
      </div>
    </section>
  );
}